import { render, staticRenderFns } from "./EcotypeSearch.vue?vue&type=template&id=4979ed9f&scoped=true"
import script from "./EcotypeSearch.vue?vue&type=script&lang=js"
export * from "./EcotypeSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4979ed9f",
  null
  
)

export default component.exports